
import { ArrowRight } from "lucide-react";
import { Button, ContactButton } from "@/components/ui/button";
import { Container } from "@/components/ui/container";
import { HeroBackground } from "@/components/ui/hero-background";

export const HeroSection = () => {
  const scrollToSection = (sectionId: string) => {
    // Adding a short timeout to ensure DOM is fully loaded
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      } else {
        console.error(`Section with id "${sectionId}" not found`);
      }
    }, 100);
  };

  return (
    <HeroBackground 
      pattern="roadmap" 
      colorScheme="purple" 
      height="h-[600px] md:h-[700px]"
      className="animate-fade-in"
    >
      {/* Content container */}
      <Container className="py-12">
        <div className="max-w-4xl mx-auto text-center">
          <h1 id="hero-heading" className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight tracking-tight text-gray-900 animate-fade-up">
            Cybersecurity{" "}
            <span className="bg-gradient-to-r from-edgefi-purple to-edgefi-amethyst bg-clip-text text-transparent">
              Advisory Services
            </span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed font-light animate-fade-up" style={{ animationDelay: "0.1s" }}>
            Expert guidance to develop, implement, and optimize your cybersecurity strategy. We help you navigate complex security challenges with confidence.
          </p>
          <div className="flex flex-wrap justify-center gap-4 animate-fade-up" style={{ animationDelay: "0.2s" }}>
            <ContactButton
              className="bg-edgefi-purple hover:bg-edgefi-purple/90 text-white group"
              modalTitle="Security Advisory Consultation"
              modalDescription="Tell us about your cybersecurity challenges and goals."
              variant="cta"
              size="lg"
            >
              Book a Consultation
              <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </ContactButton>
            <Button 
              variant="outline" 
              size="lg" 
              className="border-edgefi-purple/20"
              onClick={() => scrollToSection('success-stories')}
            >
              View Success Stories
            </Button>
          </div>
        </div>
      </Container>
    </HeroBackground>
  );
};
